import { useQuery } from "@tanstack/react-query";
import { useLoading } from "./LoadingContext";
import { useEffect } from "react";

const useApiQuery = ({ queryKey, queryFn, options = {}, enabled = true }) => {
  // console.log(queryKey);

  const { setIsLoading, setProgress } = useLoading();

  const queryResult = useQuery({
    queryKey,
    queryFn,
    enabled,
    ...options, // Allow extra options like onSuccess, onError, etc.
    onSettled: () => {
      setIsLoading(false);
      setProgress(100);
    },
  });
  const { isLoading, refetch } = queryResult;

  useEffect(() => {
    setIsLoading(isLoading);
    if (isLoading) {
      setProgress(0);
    }
  }, [isLoading, setIsLoading, setProgress]);

  useEffect(() => {
    if (!isLoading) {
      setProgress(100);
    }
  }, [isLoading, setProgress]);

  return { ...queryResult, isLoading, refetch };
};

export default useApiQuery;
